import React, { useState, useEffect } from "react";
import { createGrammarTopic, updateGrammarTopic } from "./adminGrammarService";

const GrammarTopicForm = ({ topic, onSaved, onCancel }) => {
  const isEdit = !!topic;
  const [form, setForm] = useState({ title: "", description: "", icon: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (topic) {
      console.log("[GrammarTopicForm] Populating form for edit, id:", topic.id);
      setForm({
        title: topic.title || "",
        description: topic.description || "",
        icon: topic.icon || "",
      });
    }
  }, [topic]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (!form.title || !form.description) {
      console.warn("[GrammarTopicForm] Validation failed: missing title or description");
      alert("Title and Description are required");
      return;
    }
    const payload = { ...form };
    console.log("[GrammarTopicForm] Submitting", isEdit ? "update" : "create", "payload:", payload);
    setLoading(true);
    const res = isEdit
      ? await updateGrammarTopic(topic.id, payload)
      : await createGrammarTopic(payload);
    if (res.status === 200 || res.status === 201) {
      console.log("[GrammarTopicForm] Submit successful:", res.status);
      onSaved();
    } else {
      console.error("[GrammarTopicForm] Submit failed:", res.status, res.message);
      alert(res.message || "Operation failed");
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
          <h2>{isEdit ? "Edit" : "Create"} Grammar Topic</h2>

          <div className="form-group">
            <label>Icon (emoji)</label>
            <input name="icon" placeholder="📝" value={form.icon} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Title *</label>
            <input name="title" placeholder="e.g. Parts of Speech" value={form.title} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Description *</label>
            <textarea name="description" placeholder="Brief description..." value={form.description} onChange={handleChange} rows={3} />
          </div>

          <div className="form-actions">
            <button onClick={handleSubmit} disabled={loading}>
              {loading ? "Saving..." : isEdit ? "Update" : "Create"}
            </button>
            <button onClick={onCancel} disabled={loading}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrammarTopicForm;
